export default __webpack_public_path__ + "static/media/markdown.6fca45ee.svg";